export const desmascararCpf = (cpf?: string) => (cpf || "").replace(/\D/g, "");
